import { useEffect } from 'react'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import { useCategories } from './useCategories'

const useCategory = () => {
  const { tenantUrlSlug, affiliationUrlSlug, categoryUrlSlug } = useParams()
  const { categories } = useCategories()
  const navigate = useNavigate()

  /*
  There are a couple pages that do not represent a category. They will not have
  a categoryUrlSlug due to the routing, but there is a corresponding part in
  the url: /<tenant>/<affiliation>/<page>. Check for that to prevent navigating
  to the first category
  */
  const location = useLocation()
  const path = location.pathname.split('/').filter((i) => i)
  const isPage = path.length >= 3

  useEffect(() => {
    if (categories?.length && !categoryUrlSlug && !isPage) {
      navigate(
        `/${tenantUrlSlug}/${affiliationUrlSlug}/${categories[0].urlSlug}`
      )
    }
  }, [
    categories,
    categoryUrlSlug,
    isPage,
    navigate,
    tenantUrlSlug,
    affiliationUrlSlug
  ])

  const category = categories?.find(
    (it) => it.urlSlug.toLowerCase() === categoryUrlSlug?.toLowerCase()
  )

  return { category }
}

export { useCategory }
